import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/srv/feelgood-dev2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/feelgood-dev2/src/app/components/Header.tsx");
